import React from 'react';

export const TicketBuilderContext = React.createContext();

export function withTicketBuilderContext(Component) {
    return (props) => (
        <TicketBuilderContext.Consumer>
            {(context) => <Component {...props} tb={context}/>}
        </TicketBuilderContext.Consumer>
    );
}
